module.exports = __webpack_public_path__ + "fonts/google-sans-medium.8d57e401.ttf";